var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 342 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.867 171L335.267 36.6C343.8 28.0667 343.8 15.2667 335.267 6.73334C326.733 -1.8 313.933 -1.8 305.4 6.73334L171 141.133L36.6 6.73334C28.0667 -1.8 15.2667 -1.8 6.73334 6.73334C-1.79999 15.2667 -1.79999 28.0667 6.73334 36.6L141.133 171L6.73334 305.4C2.46667 309.667 0.333336 313.933 0.333336 320.333C0.333336 333.133 8.86667 341.667 21.6667 341.667C28.0667 341.667 32.3333 339.533 36.6 335.267L171 200.867L305.4 335.267C309.667 339.533 313.933 341.667 320.333 341.667C326.733 341.667 331 339.533 335.267 335.267C343.8 326.733 343.8 313.933 335.267 305.4L200.867 171Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/red-trash.4d579ba7165e00f1b63a51a436a7424b.svg";
export { ForwardRef as ReactComponent };